if(!customElements.get('custom-cart-popup')){
    class CustomCartPopup extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.querySelectorAll('[data-type="close"]').forEach(item => {
                item.addEventListener('click', this.close.bind(this));
            })

            this.setTimeoutRunning = false;

            this.popupDuration = this.dataset.duration? parseInt(this.dataset.duration) * 1000 : 10000;
        }

        renderContent(product){
            var clone = this.querySelector('template').content.cloneNode(true);

            if(product){
                if(product.image){
                    clone.querySelector('.cart-item__image img').setAttribute('src', product.image);
                }
    
                clone.querySelectorAll('.cart-item a').forEach(item => {
                    item.setAttribute('href', product.url);
                    item.setAttribute('title', `${product.title}`);
                })
    
                clone.querySelector('.heading').innerHTML = `${product.title}`;
    
                if(clone.querySelector('.vendor'))
                    clone.querySelector('.vendor').innerHTML = `${product.vendor}`;
    
                if(clone.querySelector('.variant')){
                    clone.querySelector('.variant').innerHTML = `${product.variant_options.join(', ')}`;
                }
    
                if(clone.querySelector('.recipient') && product.properties){
                    var recipient = [];
                    for(let key in product.properties){
                        if(key == 'Recipient email' && product.properties[key] != ""){
                            recipient.push(`Recipient email: ${product.properties[key]}`);
                        }else if(key == 'Recipient name' && product.properties[key] != ""){
                            recipient.push(`Recipient name: ${product.properties[key]}`);
                        }else if(key == 'Message' && product.properties[key] != ""){
                            recipient.push(`Message: ${product.properties[key]}`);
                        }
                    }
    
                    recipient = recipient.join(", \n");
                    clone.querySelector('.recipient').innerHTML = recipient;
                    clone.querySelector('.recipient').setAttribute('data-hidden', 'false');
                }
    
                clone.querySelector('[data-type="close"]').addEventListener('click', this.close.bind(this));
            }

            this.querySelector('.cart-popup__content').innerHTML = '';
            this.querySelector('.cart-popup__content').append(clone);
            this.open();


            this.getCartSize();
        }

        getCartSize(){
            const cartItemsIconUrl = `/?section_id=header-cart-icon`;

            fetch(cartItemsIconUrl)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
          
                return res.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

                document.querySelector('custom-header .nav-item .cart-count').innerHTML = resultsMarkup;
            })
        }

        close(){
            this.setAttribute('data-hidden', 'true');
        }

        open(){
            this.setAttribute('data-hidden', 'false');

            if(this.setTimeoutRunning){
                clearTimeout(this.popupSetTimeout);
            }

            this.setTimeoutRunning = true;
            this.popupSetTimeout = setTimeout(() => {
                this.close();
                this.setTimeoutRunning = false;
            }, this.popupDuration);

        }
    }
    customElements.define('custom-cart-popup', CustomCartPopup);
}